import { isEmpty, map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button, { TYPES } from 'components/Button';
import Paragraph from 'components/Paragraph';
import Strong from 'components/Strong';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import ActiveFilterItem from './ActiveFilterItem';

const CollectionFilterOverview = ({
  filterOptions,
  clearCollectionFilter,
  clearCollectionFilters,
}) => (
  <div className="CollectionFilterOverview">
    <div className="CollectionFilterOverview__heading">
      <Paragraph className="CollectionFilterOverview__label">
        <Strong>{I18n.localize('collectionPage.filterActions.filterBy')}</Strong>
      </Paragraph>
      {!isEmpty(filterOptions) && (
        <Button
          onClick={clearCollectionFilters}
          type={TYPES.LINK}
          className="CollectionFilterOverview__clear-button"
        >
          {I18n.localize('collectionPage.filterActions.clearAll')}
        </Button>
      )}
    </div>
    <div className="CollectionFilterOverview__active-filters">
      {map(filterOptions, (option, index) => (
        <ActiveFilterItem
          key={`${option.option}_${index}`}
          option={option}
          onClick={clearCollectionFilter}
        />
      ))}
    </div>
    <style jsx>
      {`
        .CollectionFilterOverview__heading {
          display: flex;
          justify-content: space-between;
          margin-bottom: ${Theme.get('spacing') * 2}px;
        }

        .CollectionFilterOverview__active-filters {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -${Theme.get('spacing') / 2}px;
        }
      `}
    </style>
    <style jsx global>{`
      .CollectionFilterOverview__heading .Paragraph {
        margin-bottom: 0;
      }

      .CollectionFilterOverview__heading .Button {
        font-weight: ${Theme.get('font-weight-normal')};
        letter-spacing: ${Theme.get('letter-spacing-tight-px')};
      }
    `}</style>
  </div>
);

CollectionFilterOverview.propTypes = {
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({ filterIdentifier: PropTypes.string, option: PropTypes.string })
  ).isRequired,
  clearCollectionFilter: PropTypes.func.isRequired,
  clearCollectionFilters: PropTypes.func.isRequired,
};

export default CollectionFilterOverview;
